import { C as _, i as g, b as h, a as v, d as x, e as b, f as y } from "./_plugin-vue_export-helper-CvemANvM.js";
import { m as w } from "./dataAttributes-epkaQAQt.js";
import { defineComponent as S, computed as k, openBlock as A, createElementBlock as C, Fragment as M, createElementVNode as e, toDisplayString as l, createVNode as r, unref as p, withCtx as $ } from "vue";
import { b as D, u as L, e as V, _ as B, a as I, i as c, d as O, c as P } from "./EPrescriptionInputOptions.vue_vue_type_script_setup_true_lang-CtP5vjox.js";
import { u as z } from "./index-BA_m867W.js";
const E = { class: "flex w-full flex-col pb-2.5 pt-5 md:pb-4 md:pt-7" }, F = { class: "flex items-center gap-[6px] py-5 md:pb-3" }, H = { class: "text-mobile-headline-l font-bold text-secondary-500 md:text-desktop-headline-m" }, N = { class: "flex items-center gap-x-0.5" }, T = ["href"], q = ["innerHTML"], K = /* @__PURE__ */ S({
  __name: "App",
  setup(o) {
    const { md: s } = z(), a = D(), t = k(() => a.datasetUrls.ePrescriptionLink), d = L(), { toggleDialog: m, toggleInputOptionsSheet: u } = d;
    function f() {
      m(s.value), u(!s.value);
    }
    return (n, i) => (A(), C(M, null, [
      e("div", E, [
        i[1] || (i[1] = e("div", { class: "h-px w-full border-t border-t-secondary-200" }, null, -1)),
        e("div", F, [
          e("div", H, l(n.$t("eprescription_nominativ")), 1),
          e("div", N, [
            e("a", {
              href: t.value,
              class: "text-mobile-body-m text-primary-500 md:text-desktop-body-m"
            }, l(n.$t("eprescription_more_about")), 9, T),
            i[0] || (i[0] = e("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 18 19",
              fill: "none",
              class: "aspect-square w-[18px] text-primary-500 md:w-4"
            }, [
              e("path", {
                d: "M4.875 4.625v1.5h6.443l-7.193 7.193 1.058 1.057 7.192-7.192v6.442h1.5v-9h-9Z",
                fill: "currentColor"
              })
            ], -1))
          ])
        ]),
        r(p(_), {
          class: "w-full px-4 py-3 md:w-fit",
          label: n.$t("apply_eprescription"),
          variant: "tertiary",
          onClick: f
        }, {
          icon: $(() => [
            e("div", {
              innerHTML: p(V),
              class: "mr-2 h-5 w-5 text-secondary-700"
            }, null, 8, q)
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      r(B),
      r(I)
    ], 64));
  }
});
try {
  const { datasetKeys: o, datasetValues: s, messages: a } = g(c, {
    datasetStagingValues: O,
    moduleLocales: w
  }), t = h({
    App: K,
    datasetKeys: o,
    datasetValues: s
  });
  v.setActionOrigin(P), t.use(x()), t.use(
    b({
      ...y.localeSettings,
      messages: a
    })
  ), t.mount(`#${c}`);
} catch (o) {
  console.error("Failed to initialize the application:", o);
}
//# sourceMappingURL=e-prescription-order-modal.js.map
